import Select from 'react-select';

const MultiSelect = ({ labels, onChange, value, showSelectAll = false }) => {

  // Transformer l'objet labels en un tableau d'options pour le composant react-select
  let options = null;
  if(Array.isArray(labels)){
    options = Array.isArray(labels)
    ? labels.map((item) => ({
        label: item.nom, // Utilisez la propriété 'nom' de l'objet classe pour le label
        value: item.id,  // Utilisez 'id' comme valeur unique pour l'option
      }))
    : [];
  }
  else {
     options = Object.keys(labels).map((key) => ({
      label: `${key} - ${labels[key]} `, // Affiche "Écriture en français -> Écriture décimale (Q1)"
      value: key,
  }));
  }

  const handleSelectAll = () => {
    onChange(options);
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const allSelected = value?.length === options?.length;

  // Définir des styles personnalisés pour react-select
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: '12px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      backgroundColor: '#BAE6FD',
      color: 'black',
      padding: '4px 8px',
      fontSize: '13px',
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: '#BAE6FD',
      borderRadius: '6px',
      margin: '3px',
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      padding: '4px 6px',
      borderRadius: '0 6px 6px 0',
      ':hover': {
        backgroundColor: '#ef4444',
        color: 'white',
        cursor: 'pointer',
      },
    }),
  };

  return (
    <div className="flex flex-col gap-2">
      {showSelectAll && options && options.length > 0 && (
        <div className="flex gap-2">
          <button
            type="button"
            onClick={handleSelectAll}
            disabled={allSelected}
            className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
              allSelected
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'bg-sky-100 text-sky-700 hover:bg-sky-200'
            }`}
          >
            Tout sélectionner
          </button>
          <button
            type="button"
            onClick={handleClearAll}
            disabled={!value || value.length === 0}
            className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
              !value || value.length === 0
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'bg-red-100 text-red-700 hover:bg-red-200'
            }`}
          >
            Tout désélectionner
          </button>
        </div>
      )}
      <Select
        isMulti
        name="labels"
        options={options}
        styles={customStyles}
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default MultiSelect;